import { Component, Input, forwardRef, SimpleChanges, OnChanges } from '@angular/core';
import { KeyValuePair } from '../../models/models';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-drop-down',
    templateUrl: './drop-down.component.html',
    styleUrls: ['./drop-down.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropDownComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DropDownComponent implements ControlValueAccessor, OnChanges {
  @Input() placeholder: string; // used as a label
  @Input() name: string;
  @Input() items: KeyValuePair[];
  @Input() firstAsDefault = true;
  @Input() asyncItems = true;
  @Input() showClearButton = false;
  @Input() disabled = false;
  @Input() tooltip: string;
  value: string;

  // ControlValueAccessor implementation
  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  // ControlValueAccessor methods
  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const isItemsSet = (changes.items?.currentValue && (changes.items?.currentValue as any[]).length)
      || (changes.groupedItems?.currentValue && (changes.groupedItems?.currentValue as any[]).length);

    if (this.asyncItems && !this.value && isItemsSet) {
      if (this.firstAsDefault) {
        this.value = (changes.items.currentValue as KeyValuePair[])[0].id;
        this.onChange(this.value);
      }
    }
  }

  valueChanged(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  clearValue(): void {
    this.value = undefined;
    this.onChange(undefined);
    this.onTouched();
    this.valueChanged(undefined);
  }
}
